module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0",
      "height": "auto !important"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "队伍照片",
      "value": _vm.formData.heying.length + '/1'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader2', {
    attrs: {
      "fileList": _vm.formData.heying,
      "limit": 1,
      "name": 'heying'
    },
    on: {
      "imageListChange": _vm.heyingChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传一张队伍照片(横版),建议比例3x4")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("下一步")])], 1)], 1), _vm._v(" "), _c('CaipanPicker', {
    attrs: {
      "show": _vm.showCaipanPicker,
      "limit": 1,
      "danweiId": _vm.formData.danwei_id,
      "defaultValue": _vm.formData.caipan
    },
    on: {
      "onChange": _vm.onCaipanChange,
      "onClose": function($event) {
        _vm.showCaipanPicker = false
      },
      "onConfirm": _vm.onCaipanConfirm
    }
  }), _vm._v(" "), _c('JiaolianPicker', {
    attrs: {
      "show": _vm.showJiaolianPicker,
      "limit": 5,
      "danweiId": _vm.formData.danwei_id,
      "defaultValue": _vm.formData.jiaolian
    },
    on: {
      "onChange": _vm.onJiaolianChange,
      "onClose": function($event) {
        _vm.showJiaolianPicker = false
      },
      "onConfirm": _vm.onJiaolianConfirm
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47cb41b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/Uploadimg.vue
// module id = 2341
// module chunks = 0